
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import CellPlaceholder from '@components/common/cell-placeholder'
import Upload from '@components/common/upload/upload'
import { IMG_SERVER, IMG_SHOW_SERVER } from '@/consts/const'

import { validForm } from '@/utils/validData'
import { commitVioReport, getWflxList, getuserInfo } from '@/service/vioReport'
import moment from 'moment'
import CarKeyboard from '@components/common/car-keyboard'
import { hidePhone, hideXm } from '../../filters/baseFilter'
import {getAppConfig} from '../../service/vioReport'
import {fnDwHzTd, isJCSS} from '../../utils/utils'
export default {
components: {
PopupRadio,
PopupPicker,
Group,
Cell,
CellBox,
Datetime,
XInput,
XButton,
Upload,
XTextarea,
CellPlaceholder,
CarKeyboard
},
data () {
return {
wflxTips: '', // 违法类型提示
tip: '地点的示例：延安路平海路东口西向东方向/环城西路20号东向西方向', // 地址填写提示
xzqh: [],
listxw: [],
listXzqh: [],
wfxwName: '',
areaCode: '',
areaCodeName: '',
longitude: '',
latitude: '',
wfxw: [],
wfsj: '',
startDate: '',
endDate: '',
wfdz: '',
wfdd: '',
hphm: '',
wfxq: '',
file: [],
file1: [],
file2: [],
file3: [],
files: [],
files1: '',
files2: '',
files3: '',
currentAddress: '',

showImgServer: IMG_SHOW_SERVER,
imgServer: IMG_SERVER,
minSize: 3,
xm: '',
xmYc: '',
sfzmhm: '',
sjhmYc: '',
sjhm: '',
star: 0,
zjlx: '1',
bcdz: '',
isSjhmEdit: false,
isTimeEdit: true,
uploadHeader: {},
wechatConfig: null,
isShowKeyboard: false,
maxCarNumberLength: 8,
bpbg1: require('../../assets/picBg1.png'),
bpbg2: require('../../assets/picBg1.png'),
bpbg3: require('../../assets/picBg1.png'),
picnm: 0,
imgurl: sessionStorage.getItem('imgurl'),

fileUploadType: '',
showPlateType: false,
showSupplement: false,
listHpzl: [],
vioLicensePlateType: [],
listFileType: [
{
name: '照片',
value: 'pic'
},
{
name: '视频',
value: 'video'
}
],
fileType: [], // 证据文件类型
chooseFileType: ''
}
},
computed: {
imgNumerText: function () {
return this.minSize > 2 ? '必须上传3张照片' : '必须上传2张及以上照片'
},
videoName: function () {
return this.file.length === 1 ? this.file[0].name : ''
},
isPassed: function () {






if (!this.wfxw.length > 0) {
return {
msg: '请检查是否填写违法行为!',
status: false
}
}







if (this.fileUploadType === 'choose' && this.chooseFileType === '') {
return {
msg: '请选择文件类型!',
status: false
}
}
if (!this.wfsj) {
return {
msg: '请检查是否填写违法时间!',
status: false
}
}
if (!this.hphm) {
return {
msg: '请检查是否填写号牌号码!',
status: false
}
}
if (this.hphm && !validForm('hphm', this.hphm)) {
return {
msg: '请输入正确的号牌号码!',
status: false
}
}
if (this.showPlateType && this.vioLicensePlateType.length === 0) {
return {
msg: '请选择号牌种类!',
status: false
}
}
if (!this.areaCode) {
return {
msg: '请检查是否填写违法地址!',
status: false
}
}
if (!this.wfdd) {
return {
msg: '请检查是否补充违法地址!',
status: false
}
}
if (!this.wfxq) {
return {
msg: '请检查是否填写违法详情!',
status: false
}
}



if (this.xm.trim() && this.sjhm.trim()) {
} else {
return {
msg: '请将举报人信息填写完整!',
status: false
}
}
if (!validForm('phone', this.sjhm)) {
return {
msg: '请输入合法的手机号码!',
status: false
}
}

return {
msg: '',
status: true
}
}
},
watch: {








},
created () {


this.uploadHeader = { 'X-Token': localStorage.getItem('token') }
this.startDate = moment()
.subtract(3, 'days')
.format('YYYY-MM-DD')
this.endDate = moment().format('YYYY-MM-DD')
this.wfsj = moment().format('YYYY-MM-DD HH:mm:ss')
this.getWflist()
this.getUser()
},
mounted () {

this.initLocation()
},
methods: {

getChangeTxt () {
if (this.wfdd) {
























}
},
getLocationCs () {

this.initLocation()
},
getSjhm () {























},








onShowDZ () {








console.log('on show')
},
onShowHpzl () {},
onHide (type) {
console.log('on hide', type)
},
onChange (val) {
console.log('val change', this.xzqh, val)
this.areaCode = val[1]
this.areaCodeName = this.$refs.picker && this.$refs.picker.getNameValues().replace(/\s+/g, '')
if (this.areaCode) {
getWflxList('addressTips/' + this.areaCode)
.then((response) => {
const result = response.data
if (result.data[0] && result.data[0].dmmc) {
this.tip = '地点的示例：' + result.data[0].dmmc
} else {
this.tip = '地点的示例：延安路平海路东口西向东方向/环城西路20号东向西方向'
}


})
.catch((error) => {
this.listXzqh = []
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
}



},
onChangeCllx (val) {
this.chooseFileType = val[0]
},
onChangeHpzl (val) {
console.log('hpzl0000--', this.vioLicensePlateType)
},
onChangeWfxw (val) {
console.log('val change111', val)
let data = ''
let wflx = ''
this.areaCode = ''
this.areaCodeName = ''
this.wflxTips = ''
this.xzqh = []
this.tip = '地点的示例：延安路平海路东口西向东方向/环城西路20号东向西方向'
if (val[0]) {
let dataArr = this.listxw.filter(item => item.value === val[0])
data = dataArr[0].bz ? '100004/' + dataArr[0].bz : '100004'
wflx = 'wflxTips/' + val[0]
} else {
data = '100004'
wflx = 'wflxTips'
}

getWflxList(data)
.then((response) => {
const result = response.data
this.listXzqh = this.TreeToArray(result.data)

})
.catch((error) => {
this.listXzqh = []
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
getWflxList(wflx)
.then((response) => {
const result = response.data
if (result.data[0] && result.data[0].dmmc) {
this.wflxTips = result.data[0].dmmc
} else {
this.wflxTips = ''
}


})
.catch((error) => {
this.listXzqh = []
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
},

getUser () {
getuserInfo()
.then((res) => {

const result = res.data
if (result.data) {
this.star = result.data.star || '0'
this.xm = result.data.name || ''
this.sjhm = result.data.phone || ''
this.xmYc = hideXm(result.data.name || '')
this.sjhmYc = hidePhone(result.data.phone || '')

var id = '#box1'
document.querySelector(id).scrollIntoView({
behavior: 'smooth',
block: 'center',
inline: 'nearest'
})

}
})
.catch((error) => {
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
},

getWflist () {
getWflxList('wflx')
.then((response) => {
const result = response.data
this.listxw = result.data.map((item) => {
return {
name: item.dmmc,
value: item.dmbh,
bz: item.bz
}
})
})
.catch((error) => {
this.listxw = []
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
getAppConfig().then((response) => {
const result = response.data
this.showSupplement = result.data.showSupplement
this.fileUploadType = result.data.fileUploadType
this.showPlateType = result.data.showPlateType
if (this.showPlateType) {
getWflxList('plateType')
.then((response) => {
const result = response.data
this.listHpzl = result.data.map((item) => {
return {
name: item.dmmc,
value: item.dmbh,
bz: item.bz
}
})
})
}
})
},

TreeToArray (tree) {

if (!Array.isArray(tree) || !tree.length) return []
let res = []
tree.forEach((v) => {

res.push({
name: v.dmmc,
value: v.dmbh,
parent: v.front ? v.front : 0
})
if (v.next) {

res.push(...this.TreeToArray(v.next))
}
})
return res
},




















initLocation () {

if (isJCSS()) {
ZWJSBridge.onReady(() => {
ZWJSBridge.getLocation().then((result) => {

this.currentAddress = result.detailAddress

this.latitude = result.longitude
this.longitude = result.latitude




})
}).catch((error) => {
console.log(error)
})
} else {


const map = new T.Map('container')
let lo = new T.Geolocation()
const _this = this
lo.getCurrentPosition(e => {

const geocode = new T.Geocoder()
geocode.getLocation(e.lnglat, result => {
console.log('result-----====', result)
const addressComponent = result.getAddressComponent().addressComponent
_this.currentAddress =
`${addressComponent.province}${addressComponent.city}${addressComponent.county}${addressComponent.address}${addressComponent.poi}`
_this.longitude = e.lnglat.lng
_this.latitude = e.lnglat.lat
})
})
}


















},
showKeyboard () {
this.isShowKeyboard = true
},
carOnBlur () {
this.isShowKeyboard = false
},
carOnDone () {
this.isShowKeyboard = false
},
carNumberChange (number) {
this.hphm = number
if (number.length === this.maxCarNumberLength) {
this.isShowKeyboard = false
}
},
timeChange (e) {

let aa = this.get72time(e)
},
get72time (e) {
let time = new Date().getTime()
let time2 = new Date(e).getTime()
let count = time - time2
if (count > 1000 * 60 * 60 * 72) {
this.$vux.toast.show({
text: '违法时间请在72小时范围内!'
})

return true
} else {
return false
}

},
deleteImg (index) {
this.files.splice(index, 1)
},
OnStart () {
this.picnm = 1
this.$vux.loading.show({
text: '正在上传...'
})
},
OnStart1 () {
this.picnm = 2
this.$vux.loading.show({
text: '正在上传...'
})
},
OnStart2 () {
this.picnm = 3
this.$vux.loading.show({
text: '正在上传...'
})
},
OnSuccess (response) {

this.$vux.loading.hide()
if (response.data) {
this.$vux.toast.show({
text: '上传成功!'
})
this.files.push(response.data)
} else {
this.$vux.toast.show({
text: response.msg,
type: 'warn'
})
}
},
OnSuccess2 (response, fil) {

this.$vux.loading.hide()
if (response.data) {
this.$vux.toast.show({
text: '上传成功!'
})

if (this.picnm === 1) {
this.files1 = response.data
this.bpbg1 = response.data.url || response.data.serverUrl
} else if (this.picnm === 2) {
this.files2 = response.data
this.bpbg2 = response.data.url || response.data.serverUrl
} else if (this.picnm === 3) {
this.files3 = response.data
this.bpbg3 = response.data.url || response.data.serverUrl
}
} else {
this.$vux.toast.show({
text: response.msg,
type: 'warn'
})
}
},
onError (errors) {
this.$vux.loading.hide()
this.$vux.toast.show({
text: errors,
type: 'warn'
})
},
commit () {
const {
areaCode,
longitude,
latitude,
wfsj,
hphm,
wfxw,
wfdd,
areaCodeName,
xm,
sjhm,
zjlx,
wfxq,
bcdz
} = this


if (this.get72time(wfsj)) {
return
}


/**
{
hphm (string): 车牌号码 ,
hpzl (string): 号牌种类 ,
img1Id (string, optional): 图片1 ,
img2Id (string, optional): 图片2 ,
img3Id (string, optional): 图片3 ,
latitude (number): 纬度 ,
longitude (number): 经度 ,
sfzmhm (string): 身份证明号码 ,
sjhm (string): 手机号码 ,
xzqh (string): 行政区划 ,
videoId (string, optional): 视频文件 ,
wfdz (string): 违法地址 ,
wfsj (string): 违法时间 ,
wfxw (string): 违法行为 ,
xm (string): 姓名 ,
zjlx (string): 证据类型 0视频 1图片
}
*/
const opts = {
vioLicensePlate: hphm,
vioLicensePlateType: this.vioLicensePlateType[0],
currentAddress: this.currentAddress,
latitude: latitude || '',
longitude: longitude || '',
phone: sjhm,
areaCode: areaCode,
videoId: '',
areaName: areaCodeName,
vioAddress: wfdd,
vioTime: wfsj,
vioType: (wfxw && wfxw[0]) || '',
name: xm,
vioDescribe: wfxq,
picList: [],
videoList: []


}


if (!this.isPassed.status) {
this.$vux.toast.show({
text: this.isPassed.msg,
type: 'warn'
})
return
}
fnDwHzTd(this.wfdd, this.areaCode)
.then((res) => {

this.nextCommit(opts)
})
.catch((err) => {






this.$vux.alert.show({
title: '温馨提醒',
content: `当前仅支持${this.areaCodeName}，请确认填写地址！`,
onShow: () => {

},
onHide: () => {
this.nextCommit(opts)
}
})
})
},
nextCommit (opts) {
let arr = []

if (this.files1) {
arr.push(this.files1.id)
}
if (this.files2) {
arr.push(this.files2.id)
}
if (this.files3) {
arr.push(this.files3.id)
}
if (this.files[0]) {
opts.videoList.push(this.files[0].id || '')
}
opts.picList = arr



this.$vux.loading.show()

commitVioReport({ data: opts })
.then((response) => {
this.$vux.loading.hide()
const result = response.data

if (result.data) {
this.$vux.toast.show({
text: result.data.csz
})
sessionStorage.setItem('currentType', 1)
setTimeout(() => {
this.$router.replace({
name: 'vioReportIndex',
path: '/vioReportIndex'
})
}, 1500)
} else {
this.$vux.toast.show({
text: result.msg,
type: 'warn'
})
}
})
.catch((error) => {
console.log(error, '00000000')
this.$vux.loading.hide()
this.$vux.toast.show({
text: error.msg,
type: 'warn'
})
})

}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/ReportMain.vue